import React, { FC } from 'react';

// Eight squares around a circle whose corners round off progressively, so the shape reads
// as square at one end of the orbit and circular at the other. Geometry is the brand mark's.
const ORBIT = [
  { x: 10.1, y: 21.14, size: 5.423, radius: 0.362 },
  { x: 17.88, y: 17.93, size: 5.423, radius: 0.813 },
  { x: 21.06, y: 10.58, size: 5.423, radius: 1.175 },
  { x: 17.88, y: 3.14, size: 5.423, radius: 1.537 },
  { x: 10.1, y: 0, size: 5.423, radius: 1.898 },
  { x: 2.96, y: 3.14, size: 5.423, radius: 2.35 },
  { x: 0, y: 10.58, size: 5.423, radius: 2.712 },
  { x: 3.77, y: 18.76, size: 3.819, radius: 9.039 },
];

const OrbitMark: FC = () => (
  <svg
    width="26.483"
    height="26.563"
    viewBox="0 0 26.483 26.563"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    {/* The coordinates above are the design's pre-rotation ones, so the whole orbit turns
        half a revolution: without this the corner rounding runs the wrong way round. */}
    <g transform="rotate(180 13.2415 13.2815)">
      {ORBIT.map((dot) => (
        <rect
          key={`${dot.x}-${dot.y}`}
          x={dot.x}
          y={dot.y}
          width={dot.size}
          height={dot.size}
          rx={dot.radius}
          fill="#333"
        />
      ))}
    </g>
  </svg>
);

export default OrbitMark;
